import { render, staticRenderFns } from "./quest.vue?vue&type=template&id=55953994&scoped=true&"
import script from "./quest.vue?vue&type=script&lang=js&"
export * from "./quest.vue?vue&type=script&lang=js&"
import style0 from "./quest.vue?vue&type=style&index=0&id=55953994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55953994",
  null
  
)

export default component.exports